<button pButton 
    class="p-button-rounded p-button-help"
    icon="pi pi-question-circle"
    (click)="display=true"
    style="position: fixed; bottom: 20px; left: 20px; z-index: 1000;">
</button>

<p-dialog header="{{'Tutorial Video' | translator}}" [(visible)]="display" [modal]="true" [style]="getDialogStyle()" >
    <video #videoPlayer width="100%" controls>
        <source src="assets/kGate_tutorial.webm" type="video/mp4">
        {{"Your browser does not support the video tag." | translator }}
    </video>
    
    <ng-template pTemplate="footer">
        <button pButton type="button" label="{{'Close' | translator}}" (click)="display=false"></button>
    </ng-template>
</p-dialog>